import { Button, Card, Skeleton, DatePicker, Spin } from "antd";
import React, { useEffect, useState } from "react";

import ReactApexChart from "react-apexcharts";
// import dayjs from "dayjs";
import { TimePicker } from "antd";

import {
  filterDataByTimeRange,
  generatedISOFormatDateString,
  groupDataByInterval,
  groupDataByIntervalRhAndTemp,
  setUTCDate,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import ExportToExel from "../../../../../Elements/Grid/Export";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";
import SteamTreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";

const { RangePicker } = TimePicker;

const 
TempComparativeReport = () => {
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState();
  const [chartSkip, setChartSkip] = useState(true);
  const [chartInput, setChartInput] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [aggregationError, setAggregationError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [aggregationTime, setAggregationtime] = useState(null);
  const [data, setData] = useState([]);

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;


  const [chartLoading, setChartLoading] = useState(false);

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
  const [aggeregationResData, setaggeregationResData] = useState([]);
  const [paraError, setParaError] = useState();


  const dummyData = [
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:59:44.67"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:59:43.63"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:58:40.863"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:58:39.843"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:57:37.07"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:57:36.03"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:56:33.173"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:56:32.13"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:55:29.247"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:55:28.203"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:54:34.777"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:54:33.723"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:53:30.913"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:53:29.863"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:52:27.1"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:52:26.06"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:51:23.273"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:51:22.247"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:50:19.517"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:50:18.473"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:49:15.657"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:49:14.613"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:48:11.857"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:48:10.807"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:47:07.897"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:47:06.857"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:46:04.073"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:46:03.033"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:45:00.223"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:44:59.197"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:44:05.68"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:44:04.643"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:43:01.827"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:43:00.787"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:41:58.03"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:41:56.99"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:40:54.187"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:40:53.147"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:39:50.43"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:39:49.377"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:38:46.6"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:38:45.56"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:37:42.72"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:37:41.68"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:36:38.84"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:36:37.787"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:35:34.917"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:35:33.873"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:34:31.08"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:34:30.04"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:33:27.22"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:33:26.173"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:32:23.327"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:32:22.287"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:31:19.477"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:31:18.443"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:30:15.737"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:30:14.693"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:29:11.967"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:29:10.943"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:28:08.283"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:28:07.243"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:27:04.423"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:27:03.387"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:26:00.537"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:25:59.503"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:24:56.733"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:24:55.693"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:23:52.933"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:23:51.893"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:22:49.093"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:22:48.063"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:21:45.28"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:21:44.233"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:20:41.317"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:20:40.28"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:19:37.48"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:19:36.427"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:18:33.543"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:18:32.513"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:17:29.787"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:17:28.733"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:16:26.053"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:16:25.013"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:15:22.267"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:15:21.223"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:14:18.51"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:14:17.463"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:13:14.673"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:13:13.637"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:12:10.847"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:12:09.803"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:11:06.973"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:11:05.95"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:10:03.153"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:10:02.117"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:08:59.417"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:08:58.377"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:07:55.5"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:07:54.46"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:06:51.653"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:06:50.603"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:05:47.767"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:05:46.723"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:04:43.983"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:04:42.95"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:03:40.223"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:03:39.17"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:02:36.393"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:02:35.353"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:01:32.56"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:01:31.517"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T07:00:28.667"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T07:00:27.61"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:59:24.8"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:59:23.767"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:58:20.967"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:58:19.923"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:57:17.067"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:57:16.033"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:56:13.233"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:56:12.19"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:55:18.71"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:55:17.667"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:54:14.937"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:54:13.91"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:53:11.09"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:53:10.05"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:52:07.223"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:52:06.18"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:51:03.297"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:51:02.26"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:49:59.56"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:49:58.54"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:48:55.727"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:48:54.683"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:47:51.897"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:47:50.84"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:46:48.037"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:46:46.997"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:45:44.1"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:45:43.043"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:44:40.317"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:44:39.283"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:43:36.577"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:43:35.553"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:42:32.75"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:42:31.707"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:41:28.947"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:41:27.88"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:40:25.117"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:40:24.077"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:39:21.29"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:39:20.25"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:38:17.47"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:38:16.433"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:37:13.56"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:37:12.527"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:36:09.777"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:36:08.747"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:35:05.98"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:35:04.94"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:34:02.07"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:34:01.037"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:33:07.49"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:33:06.437"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:32:03.62"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:32:02.58"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:30:59.717"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:30:58.67"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:29:55.91"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:29:54.877"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:28:51.983"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:28:50.943"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:27:48.08"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:27:47.04"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:26:44.167"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:26:43.127"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:25:40.37"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:25:39.33"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:24:36.49"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:24:35.447"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:23:32.643"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:23:31.603"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:22:28.83"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:22:27.783"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:21:24.967"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:21:23.923"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:20:21.067"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:20:20.05"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:19:17.17"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:19:16.127"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:18:13.34"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:18:12.307"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:17:09.533"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:17:08.493"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:16:05.687"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:16:04.657"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:15:01.883"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:15:00.84"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:13:58.073"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:13:57.047"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:12:54.317"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:12:53.277"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:11:50.46"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:11:49.423"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:10:46.683"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:10:45.643"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:09:52.19"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:09:51.133"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:08:57.633"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:08:56.59"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:07:53.74"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:07:52.703"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:06:49.873"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:06:48.847"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:05:46.06"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:05:45.027"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:04:42.277"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:04:41.243"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:03:38.45"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:03:37.413"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:02:34.677"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:02:33.62"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:01:30.87"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:01:29.847"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T06:00:27.003"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T06:00:25.96"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:59:23.173"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:59:22.147"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:58:19.303"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:58:18.277"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:57:15.44"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:57:14.41"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:56:11.573"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:56:10.54"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:55:07.74"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:55:06.7"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:54:03.823"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:54:02.793"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:52:59.927"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:52:58.89"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:52:05.433"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:52:04.39"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:51:01.65"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:51:00.61"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:49:57.773"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:49:56.727"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:48:53.933"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:48:52.893"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:47:50.093"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:47:49.06"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:46:46.24"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:46:45.193"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:45:42.373"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:45:41.337"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:44:38.573"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:44:37.547"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:43:34.813"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:43:33.76"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:42:30.973"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:42:29.937"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:41:27.12"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:41:26.087"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:40:23.253"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:40:22.223"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:39:19.503"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:39:18.467"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:38:15.68"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:38:14.633"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:37:11.813"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:37:10.79"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:36:08.153"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:36:07.13"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:35:04.4"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:35:03.373"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:34:00.6"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:33:59.567"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:32:56.863"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:32:55.823"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:31:53.11"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:31:52.077"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:30:49.547"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:30:48.513"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:29:46.06"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:29:45.027"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:28:42.313"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:28:41.287"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:27:38.49"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:27:37.457"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:26:34.507"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:26:33.477"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:25:30.657"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:25:29.607"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:24:26.933"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:24:25.89"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:23:23.117"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:23:22.077"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:22:19.297"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:22:18.267"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:21:15.45"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:21:14.417"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:20:11.667"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:20:10.643"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:19:07.877"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:19:06.843"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:18:04.1"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:18:03.073"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:17:00.357"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:16:59.32"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:15:56.55"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:15:55.523"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:14:52.75"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:14:51.707"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:13:48.93"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:13:47.89"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:12:45.073"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:12:44.02"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:11:41.25"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:11:40.217"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:10:46.753"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:10:45.703"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:09:42.943"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:09:41.893"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:08:39.137"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:08:38.09"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:07:35.25"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:07:34.207"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:06:31.257"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:06:30.24"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:05:27.463"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:05:26.437"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:04:33.03"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:04:31.99"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:03:29.113"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:03:28.083"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:02:25.3"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:02:24.263"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:01:21.35"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:01:20.323"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T05:00:17.553"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T05:00:16.517"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:59:13.8"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:59:12.76"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:58:09.99"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:58:08.963"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:57:06.193"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:57:05.157"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:56:02.357"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:56:01.3"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:54:58.433"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:54:57.393"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:53:54.55"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:53:53.533"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:52:50.667"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:52:49.623"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:51:46.803"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:51:45.767"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:50:42.933"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:50:41.887"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:49:39.147"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:49:38.097"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:48:35.23"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:48:34.207"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:47:31.487"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:47:30.453"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:46:27.667"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:46:26.643"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:45:23.78"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:45:22.737"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:44:20"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:44:18.967"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:43:16.167"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:43:15.123"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:42:12.28"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:42:11.257"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:41:08.543"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:41:07.49"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:40:04.667"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:40:03.627"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:39:00.79"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:38:59.75"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:37:56.967"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:37:55.927"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:36:53.107"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:36:52.067"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:35:49.203"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:35:48.18"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:34:45.45"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:34:44.423"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:33:41.693"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:33:40.65"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:32:37.763"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:32:36.73"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:31:33.967"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:31:32.933"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:30:30.12"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:30:29.08"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:29:26.437"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:29:25.42"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:28:22.59"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:28:21.567"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:27:18.733"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:27:17.693"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:26:14.94"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:26:13.887"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:25:11.073"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:25:10.033"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:24:07.347"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:24:06.32"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:23:03.543"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:23:02.523"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:21:59.83"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:21:58.79"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:20:56.007"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:20:54.963"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:20:01.517"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:20:00.48"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:18:57.697"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:18:56.667"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:17:53.857"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:17:52.813"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:16:50.06"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:16:49.02"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:15:46.233"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:15:45.2"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:14:42.377"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:14:41.33"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:13:38.533"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:13:37.497"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:12:34.623"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:12:33.583"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:11:30.753"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:11:29.71"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:10:26.99"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:10:25.933"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:09:23.087"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:09:22.043"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:08:28.5"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:08:27.457"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:07:24.657"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:07:23.62"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:06:20.81"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:06:19.777"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:05:16.903"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:05:15.867"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:04:13.123"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:04:12.087"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:03:09.257"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:03:08.213"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:02:05.477"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:02:04.427"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T04:01:01.607"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T04:01:00.567"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:59:57.877"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:59:56.833"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:58:54.037"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:58:53.007"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:57:50.23"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:57:49.197"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:56:46.363"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:56:45.343"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:55:42.47"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:55:41.42"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:54:38.573"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:54:37.517"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:53:34.663"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:53:33.62"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:52:30.79"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:52:29.75"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:51:26.957"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:51:25.933"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:50:23.22"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:50:22.183"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:49:19.35"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:49:18.313"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:48:15.493"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:48:14.443"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:47:11.717"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:47:10.68"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:46:07.827"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:46:06.787"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:45:03.97"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:45:02.94"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:44:00.29"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:43:59.25"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:42:56.34"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:42:55.3"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:41:52.52"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:41:51.487"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:40:48.713"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:40:47.673"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:39:44.803"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:39:43.78"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:38:40.953"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:38:39.907"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:37:37.123"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:37:36.08"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:36:33.303"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:36:32.253"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:35:29.51"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:35:28.46"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:34:35.017"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:34:33.96"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:33:31.163"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:33:30.123"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:32:27.233"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:32:26.197"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:31:23.343"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:31:22.32"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:30:19.543"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:30:18.493"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:29:15.693"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:29:14.657"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:28:12.003"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:28:10.97"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:27:08.15"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:27:07.11"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:26:04.247"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:26:03.223"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:25:00.383"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:24:59.343"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:23:56.58"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:23:55.537"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:22:52.76"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:22:51.737"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:21:48.96"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:21:47.91"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:20:45.053"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:20:44.013"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:19:41.217"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:19:40.183"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:18:46.58"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:18:45.53"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:17:42.807"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:17:41.763"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:16:39"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:16:37.98"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:15:35.153"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:15:34.117"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:14:31.37"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:14:30.33"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:13:27.467"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:13:26.41"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:12:23.563"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:12:22.523"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:11:19.797"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:11:18.76"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:10:15.95"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:10:14.92"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:09:12.197"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:09:11.163"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:08:08.397"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:08:07.353"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:07:04.54"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:07:03.513"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:06:00.687"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:05:59.643"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:04:56.913"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:04:55.877"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:03:53.097"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:03:52.043"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:02:49.213"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:02:48.167"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:01:45.397"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:01:44.367"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T03:00:41.58"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T03:00:40.55"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:59:37.817"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:59:36.773"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:58:33.987"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:58:32.96"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:57:30.167"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:57:29.123"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:56:26.227"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:56:25.187"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:55:22.367"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:55:21.33"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:54:18.503"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:54:17.48"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:53:14.583"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:53:13.563"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:52:10.713"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:52:09.673"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:51:06.94"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:51:05.9"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:50:03.153"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:50:02.117"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:48:59.353"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:48:58.313"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:47:55.507"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:47:54.47"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:46:51.713"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:46:50.673"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:45:47.877"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:45:46.857"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:44:44.09"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:44:43.05"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:43:40.15"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:43:39.107"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:42:36.28"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:42:35.253"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:41:32.443"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:41:31.393"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:40:28.65"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:40:27.617"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:39:24.82"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:39:23.78"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:38:21.153"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:38:20.123"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:37:17.367"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:37:16.33"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:36:13.673"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:36:12.65"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:35:09.827"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:35:08.787"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:34:05.933"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:34:04.903"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:33:02.117"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:33:01.073"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:31:58.257"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:31:57.227"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:30:54.423"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:30:53.39"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:29:50.543"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:29:49.49"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:28:55.947"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:28:54.917"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:27:52.093"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:27:51.057"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:26:48.233"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:26:47.21"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:25:44.433"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:25:43.41"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:24:40.62"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:24:39.597"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:23:36.8"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:23:35.763"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:22:32.92"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:22:31.893"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:21:29.007"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:21:27.973"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:20:25.137"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:20:24.09"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:19:21.223"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:19:20.203"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:18:17.417"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:18:16.377"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:17:13.66"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:17:12.617"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:16:09.913"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:16:08.887"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:15:06.133"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:15:05.097"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:14:02.403"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:14:01.353"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:12:58.623"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:12:57.583"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:11:54.833"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:11:53.79"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:10:51.013"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:10:49.973"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:09:47.267"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:09:46.21"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:08:43.363"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:08:42.323"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:07:39.47"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:07:38.433"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:06:35.6"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:06:34.547"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:05:31.707"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:05:30.667"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:04:27.903"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:04:26.863"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:03:24.16"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:03:23.127"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:02:20.323"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:02:19.283"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:01:16.53"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:01:15.493"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T02:00:21.993"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T02:00:20.97"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:59:18.16"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:59:17.123"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:58:14.357"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:58:13.313"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:57:10.58"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:57:09.54"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:56:06.71"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:56:05.677"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:55:02.927"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:55:01.89"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:53:59.197"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:53:58.147"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:52:55.433"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:52:54.403"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:51:51.613"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:51:50.567"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:50:47.67"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:50:46.647"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:49:53.173"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:49:52.13"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:48:49.36"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:48:48.333"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:47:45.51"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:47:44.47"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:46:41.653"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:46:40.613"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:45:37.767"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:45:36.743"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:44:33.923"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:44:32.87"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:43:30.117"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:43:29.077"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:42:26.287"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:42:25.247"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:41:22.327"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:41:21.29"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:40:18.533"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:40:17.493"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:39:14.683"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:39:13.637"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:38:10.91"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:38:09.883"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:37:16.38"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:37:15.333"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:36:12.573"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:36:11.523"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:35:08.78"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:35:07.737"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:34:04.927"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:34:03.89"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:33:01.12"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:33:00.083"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:31:57.323"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:31:56.28"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:30:53.417"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:30:52.39"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:29:49.65"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:29:48.607"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:28:45.813"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:28:44.78"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:27:42.07"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:27:41.013"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:26:38.157"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:26:37.12"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:25:43.65"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:25:42.62"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:24:39.793"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:24:38.767"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:23:35.893"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:23:34.863"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:22:31.97"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:22:30.927"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:21:28.17"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:21:27.13"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:20:24.263"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:20:23.243"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:19:20.513"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:19:19.487"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:18:16.677"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:18:15.647"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:17:12.83"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:17:11.793"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:16:08.933"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:16:07.893"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:15:05.147"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:15:04.107"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:14:01.257"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:14:00.227"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:12:57.397"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:12:56.347"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:11:53.607"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:11:52.57"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:10:49.8"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:10:48.747"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:09:45.96"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:09:44.907"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:08:42.08"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:08:41.06"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:07:47.647"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:07:46.597"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:06:43.893"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:06:42.853"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:05:40.003"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:05:38.983"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:04:36.14"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:04:35.107"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:03:32.39"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:03:31.343"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:02:28.62"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:02:27.583"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:01:24.703"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:01:23.663"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T01:00:20.95"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T01:00:19.893"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:59:16.973"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:59:15.93"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:58:13.287"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:58:12.253"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:57:09.45"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:57:08.41"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:56:05.59"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:56:04.553"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:55:01.703"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:55:00.667"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:53:57.94"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:53:56.897"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:52:54.14"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:52:53.11"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:51:50.41"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:51:49.377"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:50:46.587"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:50:45.55"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:49:42.79"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:49:41.747"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:48:38.933"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:48:37.887"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:47:35.083"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:47:34.043"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:46:31.297"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:46:30.26"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:45:27.383"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:45:26.343"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:44:23.543"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:44:22.5"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:43:19.7"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:43:18.667"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:42:15.883"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:42:14.863"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:41:12.003"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:41:10.977"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:40:08.19"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:40:06.997"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:39:04.177"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:39:03.137"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:38:00.31"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:37:59.273"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:36:56.483"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:36:55.437"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:35:52.677"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:35:51.627"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:34:48.833"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:34:47.81"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:33:44.947"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:33:43.913"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:32:41.11"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:32:40.067"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:31:37.313"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:31:36.277"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:30:33.493"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:30:32.453"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:29:29.64"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:29:28.61"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:28:25.803"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:28:24.763"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:27:22.02"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:27:20.987"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:26:18.187"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:26:17.15"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:25:14.327"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:25:13.283"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:24:10.51"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:24:09.49"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:23:06.693"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:23:05.647"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:22:02.89"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:22:01.867"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:20:59.03"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:20:57.99"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:19:55.183"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:19:54.16"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:18:51.373"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:18:50.32"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:17:47.573"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:17:46.523"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:16:43.74"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:16:42.697"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:15:39.843"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:15:38.79"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:14:35.967"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:14:34.923"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:13:32.11"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:13:31.083"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:12:28.27"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:12:27.25"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:11:24.473"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:11:23.447"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:10:20.6"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:10:19.557"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:09:16.743"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:09:15.723"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:08:12.973"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:08:11.92"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:07:09.107"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:07:08.063"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:06:05.39"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:06:04.34"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:05:01.613"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:05:00.57"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:03:57.81"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:03:56.79"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:02:54"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:02:52.94"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:01:50.147"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:01:49.103"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 0,
        "temperature": 0,
        "createdON": "2024-10-10T00:00:46.267"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 49,
        "temperature": 26,
        "createdON": "2024-10-10T00:00:45.217"
    }
]


   const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        id: "Comparative-report",
        height: 350,
        type: "line",
        zoom: {
          type: "x",
          enabled: true,
          // autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
        },
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        floating: false,
        fontSize: '14px',
        fontFamily: 'Helvetica, Arial',
        fontWeight: 400,
        formatter: undefined,
        inverseOrder: false,
        width: undefined,
        height: undefined,
        tooltipHoverFormatter: undefined,
        customLegendItems: [],
        offsetX: 0,
        offsetY: 0,
        labels: {
            colors: undefined,
            useSeriesColors: false
        },
        markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: '#fff',
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
        },
        itemMargin: {
            horizontal: 5,
            vertical: 10
        },
        onItemClick: {
            toggleDataSeries: true
        },
        onItemHover: {
            highlightDataSeries: false
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 5,
        strokeOpacity: 0.3,
        hover: {
          size: undefined,
          sizeOffset: 3,
        },
      },
      title: {
        // display: true,
        text: "Comparative Chart",
        // color:  'red',
  
        style: {
   color: isdarkMode ? "#FFFFFF" : "#000000",
              // className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"}`
           fontSize: "18px", 
           fontWeight: "bold" },
        
      },
      xaxis: {
        categories: [],
        labels: { 
          style: { 
            color: "red",
          }
        },
        title: { 
          text: "Date", 
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          }
        }
      },
      yaxis: {
        title: {
          text: "Value",
        },
      },
      // tooltip: {
      //   y: [
      //     {
      //       title: {
      //         formatter: function (val) {
      //           return val + " (mins)";
      //         },
      //       },
      //     },
      //     {
      //       title: {
      //         formatter: function (val) {
      //           return val + " per session";
      //         },
      //       },
      //     },
      //     {
      //       title: {
      //         formatter: function (val) {
      //           return val + "Kg";
      //         },
      //       },
      //     },
      //   ],
      // },
      tooltip: {
        x: {
          show: true,
          format: "dd-MMM",
          formatter: undefined,
        },
        y: {
          title: {
            formatter: (
              seriesName,
              { series, seriesIndex, dataPointIndex, w }
            ) => {
              const isFlowRate = seriesName.includes("rh");
              const kgLabel = isFlowRate ? " Kg/hr" : "Kg";
  
              // Assuming opts.value contains the actual y-axis value
              return seriesName ;
              // return seriesName + kgLabel;
            },
          },
        },
      },
    },
  });


  const inputData = {
    SectionID: 1,
    ConverterorGroupID: 2,
    MeterIds: "1",
    FromDate: "2023-09-21T07:15:00.000Z",
    ToDate: "2023-09-25T07:15:00.000Z",
  };


  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
    }).then((res) => {
      console.log(res)
      setflowSectionResData(res);
    }); 

    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.TEMP_GETSITES}`
      // url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
    }).then((res) => {
      console.log(res)
      setgetFlowConverterResData(res);
    });

    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
    }).then((res) => {
      console.log(res)
      setflowGroupDetailsResData(res);
    });

    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_STEAM_AGGREGATION_PERIOD}`
    }).then((res) => {
      console.log(res)
      setaggeregationResData(res);
    });


  }, [])

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.TEMP_METERS_LIST}?SiteID=${converterGroupId}`
    }).then((res) => {
      console.log(res)
      setnsGetFlowConverterResData(res);
    });

    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}`
    }).then((res) => {
      console.log(res)
      setgetFlowSteamGroupMeterResData(res);
    });
  }, [converterGroupId])




  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const aggeregationList = (aggeregationResData && aggeregationResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);




  const validateToDateInput = (
    toDateValue,
    fromDateValue,
    aggregationPeriod,
    label
  ) => {
    switch (aggregationPeriod) {
      case 1: {
        // Validate if the time difference is a multiple of 15 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % 15 === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 15 minutes for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 hour for ${label}`;
        }

        return error;
      }
      case 2: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % 60 === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 8 * 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 60 minutes for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 8 hours for ${label}`;
        }

        return error;
      }
      case 3: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 24) === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 7 * 24 * 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 24 hours for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 week for ${label}`;
        }

        return error;
      }
      case 4: {
        // Validate if the time difference is a multiple of 60 minutes
        const fromDate = new Date(fromDateValue);
        const toDate = new Date(toDateValue);

        const monthsDifference =
          (toDate.getUTCFullYear() - fromDate.getUTCFullYear()) * 12 +
          (toDate.getUTCMonth() - fromDate.getUTCMonth());

        const isMultipleOf15Minutes = monthsDifference % 1 === 0; // Check if it's a whole number of months
        const isAtLeast6Months = monthsDifference >= 6;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 1 month for ${label}`;
        } else if (!isAtLeast6Months) {
          error = `Minimum time difference must be 6 months for ${label}`;
        }

        return error;
      }
      case 5: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 8) === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 24 * 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 8 hours for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 day for ${label}`;
        }

        return error;
      }
      default: {
        // Handle invalid aggregation period
        return `Invalid aggregation period: ${aggregationPeriod}`;
      }
    }
  };

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };
  const handleChangeAggregation = (value) => {
    setAggregationtime(value);
    if (value) {
      setAggregationError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 1,
      MeterIds: ids || [1],
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
    };
    getResponse(inputData)
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
  };

  useEffect(() => {
    setChartInputData();
  }, []);

  useEffect(() => {
    setChartSkip(!chartSkip);
    updateChart();
  }, [data]);

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };


  const getResponse = (inputData) => {
    console.log(inputData)

    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_COMPARATIVE_TEMPERATURE}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
      // url: `${APIConstants.GET_STEAM_DASHBOARD_HISTORICAL_DETAILS}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}` 
    }).then((res) => {
    
      setIsLoading(false)
      console.log(res.length)
      console.log(res[0])
      if (res.length>0) {
      chartEntries(res)
        setData(res);
      }
    });
  }

  const chartEntries = (data)=>{
    console.log(data)
    const toDateError = validateToDateInput(
      toDateString,
      fromDateString,
      aggregationTime,
      "From Date"
    );
    const fromDate = new Date(fromDateString);
    const aggregationName = aggeregationResData.find(
      (aggregation) => aggregation.aggregationPeriodID === aggregationTime
    ).aggregationPeriodName;

    const period =
      aggregationName === "15Mins"
        ? "min"
        : aggregationName === "60Min Report"
          ? "min"
          : aggregationName === "24Hours Report"
            ? "day"
            : aggregationName === "Monthly Report"
              ? "month"
              : "min";

    const interval =
      aggregationName === "15Mins"
        ? 15
        : aggregationName === "60Min Report"
          ? 60
          : aggregationName === "24Hours Report"
            ? 1
            : aggregationName === "Monthly Report"
              ? 1
              : 480;

    const seriesData = groupDataByIntervalRhAndTemp(
      data,
      interval,
      period,
      fromDate 
    );
 
    const input = seriesData?.chartArray;

    const inputArr = input;
    const dateArray = seriesData?.firstRecordCreatedONArray;
    console.log(dateArray) 
    console.log(inputArr)  

    // update in columnData
    setChartData((prevChartData) => ({
      series: inputArr || [],
      options: {
        ...prevChartData.options,
        xaxis: {
          ...prevChartData.options.xaxis,
          categories: dateArray || [1],
        },
      },
    }));
  }

  const handleSubmit = async () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateToDateInput(
      toDateString,
      fromDateString,
      aggregationTime,
      "From Date"
    );
    const aggregationError = validateInput(aggregationTime, "Aggregation");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    // setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);
    setAggregationError(aggregationError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError &&
      !aggregationError
    ) {
      onClose();

      const ids = selectedMeterIds?.map((id) => id).join(",");

      const fromDate = new Date(fromDateString);
      const toDate = new Date(toDateString);

      const fromHours = fromDate.getUTCHours();
      const fromMinutes = fromDate.getUTCMinutes();
      const fromSeconds = fromDate.getUTCSeconds();

      const toHours = toDate.getUTCHours();
      const toMinutes = toDate.getUTCMinutes();
      const toSeconds = toDate.getUTCSeconds();

      // Set the UTC hours, minutes, and seconds
      fromDate.setUTCHours(fromHours);
      fromDate.setUTCMinutes(fromMinutes);
      fromDate.setUTCSeconds(fromSeconds);

      toDate.setUTCHours(toHours);
      toDate.setUTCMinutes(toMinutes);
      toDate.setUTCSeconds(toSeconds);

      const formattedFromDate = generatedISOFormatDateString(fromDate);
      const formattedToDate = generatedISOFormatDateString(toDate);

      try {
        const inputData = {
          SectionID: Number(sectionId) || 1,
          ConverterorGroupID: Number(converterGroupId) || 40,
          MeterIds: ids || ["1"],
          FromDate: formattedFromDate || "2023-09-21T15:52:20.000Z",
          ToDate: formattedToDate || "2023-09-21T15:58:20.000Z",
        };

        setIsLoading(true); 
        const respone = getResponse(inputData)
        console.log(respone)



        console.log('first data')
        console.log(data)
        // chartEntries();

      
      } catch (err) {
        console.log(err);
      }finally {
        setIsLoading(false); 
      }
    }
  };

  const updateChart = async () => {
    try {
      setChartLoading(true);
      const selectedMeterData = data?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterid)
      );
      // transform the data in a chart series format
      const transformData = (property, meterName) => {
        const data = selectedMeterData
          ?.filter((item) => item?.metername === meterName)
          ?.map((item) => item[property]);
        const seriesData = {
          name: `${property}-${meterName}`, // Concatenate property and METERNAME
          data,
        };
        return seriesData;
      };
      const properties = selectedValues;
      const seriesData = [];

      // Iterate over selected meter IDs and properties
      selectedMeterIds?.forEach((id) => {
        const meterName =
          sectionId === 1
            ? nsGetFlowConverterList?.find(
              (item) => item?.meterid === Number(id)
            ).metername
            : getFlowSteamGroupMeterList?.find(
              (item) => item?.meterID === Number(id)
            ).meterName;
        properties.forEach((property) => {
          seriesData.push(transformData(property, meterName));
        });
      });

      const datesArray = [];
      const date = ["createdON"];
      selectedMeterIds?.forEach((id) => {
        const meterName =
          sectionId === 1
            ? nsGetFlowConverterList?.find(
              (item) => item?.meterid === Number(id)
            ).metername
            : getFlowSteamGroupMeterList?.find(
              (item) => item?.meterID === Number(id)
            ).meterName;
        date.forEach((property) => {
          datesArray.push(transformData(property, meterName));
        });
      });
      const firstOption = selectedValues.includes("rh");
      const secondOption = selectedValues.includes("temperature");
      const finalData = seriesData?.filter((series) => {
        if (firstOption && secondOption) {
          // Both options selected, keep all series
          return true;
        } else if (firstOption) {
          // First option selected, add series with "FlowRate"
          return series.name.includes("rh");
        } else if (secondOption) {
          // Second option selected, add series with "Cumulative"
          return series.name.includes("temperature");
        }
        // If neither option selected, keep all series
        return true;
      });

      const reversedDate = datesArray.reduce((largest, current) => {
        if (!largest || current.data.length > largest.data.length) {
          return { ...current, data: [...current.data].reverse() };
        }
        return largest;
      }, null);

      const reversedFinalData = finalData.map((data) => {
        return { data: data.data.reverse(), name: data.name };
      });

      // // x axis input
      const localDateTime = reversedDate?.data?.map((date) =>
        new Date(date).toLocaleString("en-US")
      );
      console.log(reversedFinalData)
      // update in columnData
      // setChartData((prevChartData) => ({ 
      //   series: reversedFinalData || [], 
      //   options: {
      //     ...prevChartData.options,
      //     xaxis: {
      //       ...prevChartData.options.xaxis,
      //       categories: localDateTime || [],
      //     },
      //   },
      // }));
      setChartLoading(false);
    } catch (err) {
      console.log(err);
      setChartLoading(false);
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };

  useEffect(() => {
    setChartData((prevChartData) => ({
      series: prevChartData.series || [], 
      options: {
        ...prevChartData.options,
        legend: {
          ...prevChartData.options.legend,
          labels: {
            ...prevChartData.options.legend.labels,
            colors: isdarkMode ? "#FFFFFF" : "#000000", 
          },
        },
        xaxis: {
          ...prevChartData.options.xaxis,
          labels: {
            ...prevChartData.options.xaxis.labels,
            style: {
              colors: isdarkMode ? "#FFFFFF" : "#000000", 
            },
          },
        },
        yaxis: {
          title: {
            ...prevChartData.options.yaxis.title,
            style: {
              color: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
          labels: {
            style: {
              colors: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
        },
        title: {
          ...prevChartData.options.title,
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          },
        },
      },
    }));
  }, [isdarkMode,data]); 

  const parameters = [ 
    { id: 1, name: "rh" },
    { id: 2, name: "temperature" },
  ];
  // console.log(res)
  return (
    <div id="chart" className={` relative p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
      {isLoading && (
        <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-50 dark:bg-opacity-50 z-10">
          <Spin active paragraph={{ rows: 6 }} />
        </div>
      )}


      <Card className={`p-4 rounded-md dark  ${isdarkMode ? "darkmode" : "whitemode"} 
  w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`} >
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={600}
          className="w-full"
        />
      </Card>
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            valueKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>

          <SteamTreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"
            nameKey="name"
            valueKey="name"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {/* {paraError} */}
          </small>
          <CustomSelect
            label="Aggregation period:"
            options={aggeregationList}
            onSelect={handleChangeAggregation}
            valueKey="aggregationPeriodID"
            nameKey="aggregationPeriodName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {aggregationError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">From Date:</label>
            <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={` ${isdarkMode ? 'datebackground icon' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`   ${isdarkMode ? 'datebackground icon ' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {toDateError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default TempComparativeReport
